import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useMemo, Fragment, memo, useEffect, useReducer, useCallback, useRef, useState } from 'react';
import { useWeb5Context } from "../../../lib/Web5Context";
import { generateTmpId } from "../../../lib/helpers";
import { Text, createUseStyles } from '@Sage/hoi-poi-ui';
import ForceForm, { validate, getDefaults } from "../../../components/ForceForm";
import HyperDrawer from "../../../components/HyperDrawer";
import { getValue, getValuesUsage } from "../../../lib/services/valueLists";
import styles from "./styles";
const useStyles = createUseStyles(styles, 'FormValueListValue');
const initialState = {
  id: null,
  data: {},
  usage: null,
  list: [],
  errors: {},
  isOpen: false,
  isLoading: true,
  isSaving: false,
  isForDuplicate: false
};
function reducer(state, action) {
  switch (action.type) {
    case 'init':
      return _objectSpread(_objectSpread({}, state), {}, {
        data: action.data || {},
        list: action.list,
        errors: {},
        isOpen: true,
        isLoading: false // true
      });
    case 'close':
      return _objectSpread(_objectSpread({}, state), {}, {
        isSaving: false,
        isOpen: false
      });
    case 'changeData':
      return _objectSpread(_objectSpread({}, state), {}, {
        data: action.data
      });
    case 'setErrors':
      return _objectSpread(_objectSpread({}, state), {}, {
        isSaving: false,
        errors: action.errors
      });
    case 'setSaving':
      return _objectSpread(_objectSpread({}, state), {}, {
        isSaving: action.value
      });
    case 'setUsage':
      return _objectSpread(_objectSpread({}, state), {}, {
        usage: action.data
      });
    case 'setLoading':
      return _objectSpread(_objectSpread({}, state), {}, {
        isLoading: action.value
      });
    default:
      throw new Error('No action provided');
  }
}
const FormValueListValue = _ref => {
  var _state$data$status3;
  let {
    onRef,
    schema,
    stackIndex,
    isNewValueList,
    onStack,
    onSave,
    timeZone,
    valueListName,
    overrides
  } = _ref;
  const {
    t,
    language,
    fieldsToHide = []
  } = useWeb5Context({
    overrides
  });
  const [formState, setFormState] = useState({});
  const [state, dispatch] = useReducer(reducer, initialState);
  const formFields = useRef();
  const classes = useStyles();
  const overrideIsHidden = useCallback(id => Array.isArray(fieldsToHide) && fieldsToHide.includes(id), [fieldsToHide]);
  const insertData = useCallback(data => {
    if (!data) return;
    const finalData = _objectSpread({}, data);
    if (finalData.maxCount) delete finalData.maxCount;
    const keys = Object.keys(finalData);
    return /*#__PURE__*/React.createElement(Fragment, null, keys.map((key, index) => {
      var _finalData$key;
      return /*#__PURE__*/React.createElement("div", {
        className: classes.entity,
        key: key
      }, index > 0 && /*#__PURE__*/React.createElement("div", {
        className: classes.divider
      }), /*#__PURE__*/React.createElement(Text, {
        className: classes.entityTitle,
        bold: true
      }, key), (_finalData$key = finalData[key]) === null || _finalData$key === void 0 ? void 0 : _finalData$key.map(field => /*#__PURE__*/React.createElement(Text, {
        className: classes.field,
        key: field
      }, `${t(field.description) || field.description2}: [${field.numItems <= data.maxCount ? field.numItems : t('cfm_label_related_entities_more_than', [data.maxCount])}]`)));
    }));
  }, [classes.divider, classes.entity, classes.entityTitle, classes.field, t]);

  // Child method
  useEffect(() => {
    onRef && onRef({
      open(data, list, valueListId) {
        var _schema$properties, _data, _data2, _data3, _schema$context, _schema$context$field, _schema$context$field2, _data5, _data6;
        if (!data) data = {
          isNew: true
        };
        // Hardcoding order default 0
        formFields.current = _objectSpread({}, schema);
        if (schema !== null && schema !== void 0 && (_schema$properties = schema.properties) !== null && _schema$properties !== void 0 && _schema$properties.order) {
          formFields.current = _objectSpread(_objectSpread({}, formFields.current), {}, {
            properties: _objectSpread(_objectSpread({}, schema.properties), {}, {
              order: _objectSpread(_objectSpread({}, schema.properties.order), {}, {
                default: list !== null && list !== void 0 && list.length ? list.length : 0
              })
            })
          });
        }
        const otherCompositions = formFields.current.layout.composition.slice();
        const firstComposition = otherCompositions.shift();
        formFields.current = fieldsToHide.length ? _objectSpread(_objectSpread({}, formFields.current), {}, {
          layout: _objectSpread(_objectSpread({}, formFields.current.layout), {}, {
            composition: [_objectSpread(_objectSpread({}, firstComposition), {}, {
              composition: firstComposition.composition.map(field => {
                field.isHidden = overrideIsHidden(field.schemaId || field.id) || field.isHidden;
                return field;
              })
            }), ...(otherCompositions || [])]
          })
        }) : formFields.current;
        const valueUsageInfo = {
          schemaId: 'valueUsageInfo',
          uiType: 'message',
          showCollapse: true,
          showIcon: true,
          title: /*#__PURE__*/React.createElement(Text, {
            className: classes.adviceTitle,
            bold: true
          }, t('cfm_label_related_entities'))
        };
        if ((_data = data) !== null && _data !== void 0 && _data.id && !data.isNew) getValuesUsage(valueListId, (_data2 = data) === null || _data2 === void 0 ? void 0 : _data2.id).then(_ref2 => {
          let {
            data
          } = _ref2;
          dispatch({
            type: 'setUsage',
            data
          });
        }).catch(err => console.error(err));

        // Injecting label for special field idParent
        if ((_data3 = data) !== null && _data3 !== void 0 && _data3.idParent && schema !== null && schema !== void 0 && (_schema$context = schema.context) !== null && _schema$context !== void 0 && (_schema$context$field = _schema$context.fields) !== null && _schema$context$field !== void 0 && (_schema$context$field2 = _schema$context$field.idParent) !== null && _schema$context$field2 !== void 0 && _schema$context$field2.table) {
          var _schema$context2, _schema$context2$fiel, _schema$context2$fiel2, _data4;
          getValue(schema === null || schema === void 0 ? void 0 : (_schema$context2 = schema.context) === null || _schema$context2 === void 0 ? void 0 : (_schema$context2$fiel = _schema$context2.fields) === null || _schema$context2$fiel === void 0 ? void 0 : (_schema$context2$fiel2 = _schema$context2$fiel.idParent) === null || _schema$context2$fiel2 === void 0 ? void 0 : _schema$context2$fiel2.table, (_data4 = data) === null || _data4 === void 0 ? void 0 : _data4.idParent, language).then(res => {
            var _res$data, _res$data2;
            data.idParent = {
              label: (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.description,
              value: (_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : _res$data2.id
            };
            dispatch({
              type: 'init',
              list,
              data: _objectSpread(_objectSpread({}, getDefaults(formFields.current)), data)
            });
          });
        }
        const fieldExists = formFields.current.layout.composition[0].composition.filter(el => el.schemaId === 'valueUsageInfo');
        if (!fieldExists.length) formFields.current.layout.composition[0].composition.push(valueUsageInfo);
        const timeZoneExists = Object.keys(schema.properties).find(el => el === 'timeZoneId');
        let finalData = _objectSpread({}, data);
        if ((_data5 = data) !== null && _data5 !== void 0 && _data5.order) finalData = _objectSpread(_objectSpread({}, finalData), {}, {
          order: Number((_data6 = data) === null || _data6 === void 0 ? void 0 : _data6.order)
        });
        if (timeZoneExists) finalData = _objectSpread(_objectSpread({}, finalData), {}, {
          timeZoneId: data.timeZoneId || {
            label: timeZone === null || timeZone === void 0 ? void 0 : timeZone.value,
            value: timeZone === null || timeZone === void 0 ? void 0 : timeZone.id
          }
        });
        dispatch({
          type: 'init',
          list,
          data: _objectSpread(_objectSpread({}, getDefaults(formFields.current)), finalData)
        });
      }
    });
  }, [onRef, onStack, schema, t, language, classes.adviceTitle, timeZone, overrideIsHidden, fieldsToHide]);
  const modifyFieldProps = useCallback(field => {
    var _formFields$current, _formFields$current$p, _formFields$current$p2, _formFields$current2, _formFields$current2$, _formFields$current2$2, _formFields$current2$3, _formFields$current3, _formFields$current3$, _formFields$current3$2, _formFields$current3$3, _state$data$status, _state$data$status2;
    let newField = field;
    switch (field.schemaId || field.id) {
      case 'order':
        newField = _objectSpread(_objectSpread({}, newField), {}, {
          info: t('cfm_label_value_total_values', [(formFields === null || formFields === void 0 ? void 0 : (_formFields$current = formFields.current) === null || _formFields$current === void 0 ? void 0 : (_formFields$current$p = _formFields$current.properties) === null || _formFields$current$p === void 0 ? void 0 : (_formFields$current$p2 = _formFields$current$p.order) === null || _formFields$current$p2 === void 0 ? void 0 : _formFields$current$p2.default) || 0])
        });
        break;
      case 'dependingValues':
        newField.isHidden = !((_formFields$current2 = formFields.current) !== null && _formFields$current2 !== void 0 && (_formFields$current2$ = _formFields$current2.context) !== null && _formFields$current2$ !== void 0 && (_formFields$current2$2 = _formFields$current2$.fields) !== null && _formFields$current2$2 !== void 0 && (_formFields$current2$3 = _formFields$current2$2.idParent) !== null && _formFields$current2$3 !== void 0 && _formFields$current2$3.table);
        break;
      case 'dependencyMessage':
        newField = _objectSpread(_objectSpread({}, newField), {}, {
          placeholder: t('cfm_label_value_depending_values_desc', [(_formFields$current3 = formFields.current) === null || _formFields$current3 === void 0 ? void 0 : (_formFields$current3$ = _formFields$current3.context) === null || _formFields$current3$ === void 0 ? void 0 : (_formFields$current3$2 = _formFields$current3$.fields) === null || _formFields$current3$2 === void 0 ? void 0 : (_formFields$current3$3 = _formFields$current3$2.idParent) === null || _formFields$current3$3 === void 0 ? void 0 : _formFields$current3$3.table])
        });
        break;
      case 'valueUsageInfo':
        const keys = state.usage ? Object.keys(state.usage) : null;
        newField = _objectSpread(_objectSpread({}, newField), {}, {
          placeholder: state.usage && insertData(state.usage),
          isHidden: !keys || !((keys === null || keys === void 0 ? void 0 : keys.length) > 1) || overrideIsHidden(field.schemaId || field.id)
        });
        break;
      case 'salesProbability':
        newField = _objectSpread(_objectSpread({}, newField), {}, {
          isReadOnly: ((_state$data$status = state.data.status) === null || _state$data$status === void 0 ? void 0 : _state$data$status.value) === 2 || ((_state$data$status2 = state.data.status) === null || _state$data$status2 === void 0 ? void 0 : _state$data$status2.value) === 3
        });
        break;
      case 'extId':
        newField = _objectSpread(_objectSpread({}, newField), {}, {
          hint: t('cfm_label_extid_help')
        });
        break;
      default:
        switch (field.type) {
          case 'Number':
            newField = _objectSpread(_objectSpread({}, newField), {}, {
              placeholder: t('cfm_placeholder_decimal')
            });
            break;
          case 'Integer':
            newField = _objectSpread(_objectSpread({}, newField), {}, {
              placeholder: t('cfm_placeholder_numeric')
            });
            break;
          case 'Datetime':
            newField = _objectSpread({}, newField);
            break;
          default:
            break;
        }
        break;
    }
    return newField;
  }, [insertData, overrideIsHidden, (_state$data$status3 = state.data.status) === null || _state$data$status3 === void 0 ? void 0 : _state$data$status3.value, state === null || state === void 0 ? void 0 : state.usage, t]);

  // Shared save
  const innerSave = useCallback(data => {
    if (!data.id && data.isNew) data.id = generateTmpId();
    onSave(_objectSpread(_objectSpread({}, data), {}, {
      isTouched: !!(formState && Object.keys(formState).length)
    }));
  }, [formState, onSave]);
  const onCleaningProps = useCallback((data, properties) => {
    const keys = Object.keys(properties);
    return Object.keys(data).reduce((newData, key) => {
      keys.forEach(item => {
        if (key === item) newData[key] = data[key];
      });
      return newData;
    }, {});
  }, []);
  const onSaveForm = useCallback(() => {
    let data = _objectSpread({}, state.data);
    const isNew = data.isNew;
    validate(data, formFields.current).then(_ref3 => {
      let {
        isValid,
        errors,
        cleanData
      } = _ref3;
      if (!isValid) dispatch({
        type: 'setErrors',
        errors
      });else {
        var _finalData;
        let finalData = onCleaningProps(cleanData, schema.properties);
        if (typeof ((_finalData = finalData) === null || _finalData === void 0 ? void 0 : _finalData.order) === 'string') finalData = _objectSpread(_objectSpread({}, finalData), {}, {
          order: Number(finalData.order)
        });
        onStack(1);
        dispatch({
          type: 'close'
        });
        innerSave(_objectSpread(_objectSpread({
          id: data.id
        }, finalData), {}, {
          isNew
        }));
      }
    }).catch(console.error);
  }, [innerSave, onStack, onCleaningProps, schema.properties, state.data]);
  const onSaveCreate = useCallback(() => {
    let data = _objectSpread({}, state.data);
    const isNew = data.isNew;
    validate(data, formFields.current).then(_ref4 => {
      let {
        isValid,
        errors,
        cleanData
      } = _ref4;
      if (!isValid) dispatch({
        type: 'setErrors',
        errors
      });else {
        var _finalData2;
        // We should increment default order
        if (formFields.current.properties.order) {
          formFields.current = _objectSpread(_objectSpread({}, formFields.current), {}, {
            properties: _objectSpread(_objectSpread({}, schema.properties), {}, {
              order: _objectSpread(_objectSpread({}, schema.properties.order), {}, {
                default: formFields.current.properties.order.default + 1
              })
            })
          });
        }
        let newData = _objectSpread({
          isNew: true
        }, getDefaults(formFields.current));
        let finalData = onCleaningProps(cleanData, schema.properties);
        if (typeof ((_finalData2 = finalData) === null || _finalData2 === void 0 ? void 0 : _finalData2.order) === 'string') finalData = _objectSpread(_objectSpread({}, finalData), {}, {
          order: Number(finalData.order)
        });
        innerSave(_objectSpread(_objectSpread({
          id: data.id
        }, finalData), {}, {
          isNew
        }));
        dispatch({
          type: 'init',
          data: newData
        });
      }
    }).catch(console.error);
  }, [innerSave, onCleaningProps, schema.properties, state.data]);
  const onCancel = useCallback(() => {
    dispatch({
      type: 'close'
    });
    onStack(1);
  }, [onStack]);
  const onChange = useCallback((data, field) => {
    let finalData = _objectSpread({}, data);
    if (valueListName === 'tblEstadoExpediente' && field === 'status') {
      var _finalData$status;
      const probabilityValue = ((_finalData$status = finalData.status) === null || _finalData$status === void 0 ? void 0 : _finalData$status.value) === 2 ? 100 : 0;
      finalData = _objectSpread(_objectSpread({}, finalData), {}, {
        salesProbability: probabilityValue
      });
      return dispatch({
        type: 'changeData',
        data: finalData
      });
    }
    return dispatch({
      type: 'changeData',
      data
    });
  }, [valueListName]);
  const onBlur = useCallback((data, field) => {
    let finalData = _objectSpread({}, data);
    if (field === 'order') {
      finalData = _objectSpread(_objectSpread({}, finalData), {}, {
        order: (data === null || data === void 0 ? void 0 : data.order) || 0
      });
      return dispatch({
        type: 'changeData',
        data: finalData
      });
    }
  }, []);
  const locales = useMemo(() => ({
    title: !state.data.id ? t('cfm_title_create_value') : t('cfm_title_update_value'),
    cancel: t('cfm_action_cancel'),
    save: !state.data.id ? t('cfm_action_add') : t('cfm_action_update'),
    saveAndCreate: !state.data.id ? t('cfm_action_add_not_close') : t('cfm_action_update_not_close')
  }), [state.data.id, t]);
  return /*#__PURE__*/React.createElement(HyperDrawer, {
    stackIndex: stackIndex,
    isOpen: state.isOpen,
    locales: locales,
    isLoading: state.isLoading,
    isSaving: state.isSaving,
    onCancel: onCancel,
    onSave: onSaveForm,
    onSaveCreate: state.data.isNew && !state.data.id ? onSaveCreate : undefined,
    className: "valuelist__add-value__crud__modal",
    insideCrud: true
  }, /*#__PURE__*/React.createElement(ForceForm, {
    onBlur: onBlur,
    onChange: onChange,
    onState: setFormState,
    values: state.data,
    errors: state.errors,
    schema: formFields.current,
    modifyFieldProps: modifyFieldProps,
    mode: isNewValueList ? 'create' : 'update'
  }));
};
process.env.NODE_ENV !== "production" ? FormValueListValue.propTypes = {} : void 0;
export default /*#__PURE__*/memo(FormValueListValue);